import dynamic from "next/dynamic";

import { Box } from "@chakra-ui/react";
import { GetServerSideProps } from "next";
import Head from "next/head";

const loading = () => <div>Loading...</div>;
const CookiesConsent = dynamic(
  () => import("@/components/CookiesConsent").then((mod) => mod.CookiesConsent),
  {
    loading,
  }
);
const Footer = dynamic(
  () => import("@/components/LandingPage/Footer").then((mod) => mod.Footer),
  {
    loading,
  }
);
const GetStarted = dynamic(
  () =>
    import("@/components/LandingPage/GetStarted").then((mod) => mod.GetStarted),
  {
    loading,
  }
);
const HomeHero = dynamic(
  () => import("@/components/LandingPage/HomeHero").then((mod) => mod.HomeHero),
  {
    loading,
  }
);
const Presentation = dynamic(
  () =>
    import("@/components/LandingPage/Presentation").then(
      (mod) => mod.Presentation
    ),
  {
    loading,
  }
);
const TestimonialsSection = dynamic(
  () =>
    import("@/components/LandingPage/TestimonialsSection").then(
      (mod) => mod.TestimonialsSection
    ),
  {
    loading,
  }
);
const MakeDifference = dynamic(
  () =>
    import("@/components/LandingPage/MakeDifference").then(
      (mod) => mod.MakeDifference
    ),
  {
    loading,
  }
);
const HowWeHelp = dynamic(
  () =>
    import("@/components/LandingPage/HowWeHelp").then((mod) => mod.HowWeHelp),
  {
    loading,
  }
);

import type { Metadata } from "next";

export const metadata: Metadata = {
  title: "Clarifayo",
  description: "Unlock your potential with the ultimate coaching experience!",
};

export default function Home() {
  return (
    <>
      <Head>
        <title>Clarifayo - maximize your Coaching Activity</title>
      </Head>
      <Box bgColor="black.50" className="landing-page" suppressHydrationWarning>
        <HomeHero />
        <Presentation />
        <MakeDifference />
        <HowWeHelp />
        <TestimonialsSection />
        <GetStarted />
        <Footer />
      </Box>

      <CookiesConsent />
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async () => {
  return {
    props: {},
  };
};
